export const UPDATE_ACTION_TYPE = 'UPDATE_ACTION_TYPE' // 1: 新建； 2：详情；3：修改
export const UPDATE_SELECT_CLUB = 'UPDATE_SELECT_CLUB' // 选中的俱乐部
export const UPDATE_COUPON_STATUS = 'UPDATE_COUPON_STATUS' // 在售卡券 已过期的卡券 已删除卡券
export const UPDATE_COUPON_LIST = 'UPDATE_COUPON_LIST' // 卡券列表
export const UPDATE_CLUB_TABLE_LIST = 'UPDATE_CLUB_TABLE_LIST' // 俱乐部对应的球台列表

// 操作卡券的类型
export const ACTIONTYPE = {
  ADD: 1,
  DETAIL: 2,
  EDIT: 3,
}



// WEBPACK FOOTER //
// ./src/containers/CardManage/constants.js